<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Saídas de Animais</h5>
      <b-button
        v-if="hasPermission('adicionar_saidas_animais')"
        variant="primary"
        class="d-flex align-items-center"
        @click="irParaCadastro"
      >
        <i class="bi bi-plus-circle-fill mr-2" title="Nova Saída"></i>
      </b-button>
    </div>

    <!-- Filtros -->
    <div class="d-flex mb-3 align-items-center" style="gap: 10px;">
      <span>Filtros:</span>
      <input
        v-model="filters.animal_nome"
        placeholder="Nome"
        class="form-control"
        @input="filtrarSaidas"
      />
      <input
        v-model="filters.proprietario_nome"
        placeholder="Proprietário"
        class="form-control"
        @input="filtrarSaidas"
      />
      <input
        v-model="filters.motivo"
        placeholder="Motivo"
        class="form-control"
        @input="filtrarSaidas"
      />
      <input
        v-model="filters.data_saida_prevista"
        type="text"
        placeholder="Saída prevista"
        class="form-control"
        @focus="(e) => e.target.type = 'date'"
        @blur="(e) => e.target.type = 'text'"
        @input="filtrarSaidas"
      />
      <input
        v-model="filters.data_retorno_prevista"
        type="text"
        placeholder="Retorno previsto"
        class="form-control"
        @focus="(e) => e.target.type = 'date'"
        @blur="(e) => e.target.type = 'text'"
        @input="filtrarSaidas"
      />
      <b-button variant="secondary" @click="limparFiltros" class="d-flex align-items-center justify-content-center">
        <i class="bi bi-funnel mr-2" title="Limpar Filtro"></i>
      </b-button>
    </div>

    <!-- Tabela -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="sort('animal_nome')">
              Nome {{ arrow('animal_nome') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('proprietario_nome')">
              Proprietário {{ arrow('proprietario_nome') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_saida_prevista')">
              Saída Prevista {{ arrow('data_saida_prevista') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_retorno_prevista')">
              Retorno Previsto {{ arrow('data_retorno_prevista') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_saida_efetiva')">
              Saída Efetiva {{ arrow('data_saida_efetiva') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_retorno_efetiva')">
              Retorno Efetivo {{ arrow('data_retorno_efetiva') }}
            </button>
          </th>
          <th>Motivo</th>
          <th class="text-end">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in saidas" :key="item.id">
          <td>{{ item.animal_nome }}</td>
          <td>{{ item.proprietario_nome }}</td>
          <td>{{ utils.formatarData(item.data_saida_prevista) }}</td>
          <td>{{ utils.formatarData(item.data_retorno_prevista) }}</td>
          <td>{{ utils.formatarData(item.data_saida_efetiva) }}</td>
          <td>{{ utils.formatarData(item.data_retorno_efetiva) }}</td>
          <td>{{ item.motivo || 'Não especificado' }}</td>
          <td class="text-end">
            <router-link
              v-if="hasPermission('detalhar_saidas_animais')"
              :to="`/operacional/saidas-animais/${item.id}/detalhar`"
            >
              <i class="bi bi-eye-fill text-primary me-2" title="Detalhar"></i>
            </router-link>
            <router-link
              v-if="hasPermission('alterar_saidas_animais')"
              :to="`/operacional/saidas-animais/${item.id}`"
            >
              <i class="bi bi-pencil-fill text-warning me-2" title="Editar"></i>
            </router-link>
            <i
              v-if="hasPermission('excluir_saidas_animais')"
              class="bi bi-trash-fill text-danger"
              @click="excluirSaida(item.id)"
              title="Excluir"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

      <!-- Paginação -->
      <div class="d-flex justify-content-between align-items mt-3">
        <!-- resumo -->
        <div>
          Mostrando {{ startRow }} a {{ endRow }} de {{ totalRegistros }} registros
        </div>

        <div class="d-flex align-items" style="gap: .5rem;">
                  <b-form-select
            v-model="limitePorPagina"
            :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
            size="sm"
            style="width: 6rem"
            @change="paginaAtual = 1; carregarSaidas()"
          />
        </div>

        <!-- selectors + paginação -->
        <div class="d-flex align-items">
          <b-pagination
            v-model="paginaAtual"
            :per-page="limitePorPagina"
            :total-rows="totalRegistros"
            size="sm"
            limit="5"
            @input="carregarSaidas"
          />
        </div>
      </div>
  </div>
</template>

<script>
import axios from '@/services/axios';
import { BButton, BPagination, BFormSelect } from 'bootstrap-vue-next';
import globalUtils from '@/utils/globalUtils.js';
// import { usePermissions } from '@/composables/usePermissions';

export default {
  components: { BButton, BPagination, BFormSelect },
  data() {
    return {
      saidas: [],
      filters: {
        animal_nome: '',
        proprietario_nome: '',
        motivo: '',
        data_saida_prevista: '',
        data_retorno_prevista: ''
      },
      paginaAtual: 1,
      limitePorPagina: 10,
      totalPaginas: 1,
      totalRegistros: 0,                // <-- novo
      pageOptions: [10, 15, 20, 25, 50], // <-- dropdown de limites
      sortField: 'data_saida_prevista',
      sortOrder: 'asc',
    };
  },
  computed: {
    utils() {
      return globalUtils;
    },
    startRow() {
      return (this.paginaAtual - 1) * this.limitePorPagina + 1
    },
    endRow() {
      return Math.min(this.paginaAtual * this.limitePorPagina, this.totalRegistros)
    }
  },

  watch: {
    paginaAtual() {
      this.carregarSaidas();   // dispara ao mudar de página
    }
  },

  methods: {
    async carregarSaidas() {
      try {
        const params = {
          page: this.paginaAtual,
          limit: this.limitePorPagina,
          sort: this.sortField,
          order: this.sortOrder,
          ...this.filters
        };
        const res = await axios.get('/operacional/saidas-animais', { params });

        const { data, totalPages, total } = res.data
        this.saidas = data.map((item, i) => ({
          ...item,
          seq: i + 1 + (this.paginaAtual - 1) * this.limitePorPagina
        }))
        this.totalPaginas   = totalPages
        this.totalRegistros = total     // <-- use aqui o total vindo da API
      } catch (e) {
        console.error('Erro ao carregar saídas de animais:', e);
      }
    },
    sort(col) {
      if (this.sortField === col) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = col;
        this.sortOrder = 'asc';
      }
      this.carregarSaidas();
    },
    arrow(col) {
      return this.sortField === col
        ? (this.sortOrder === 'asc' ? '▲' : '▼')
        : '';
    },
    filtrarSaidas() {
      this.paginaAtual = 1;
      this.carregarSaidas();
    },
    limparFiltros() {
      Object.assign(this.filters, {
        animal_nome: "",
        proprietario_nome: "",
        motivo: "",
        data_saida_prevista: "",
        data_retorno_prevista: ""
      });
      this.paginaAtual = 1;
      this.carregarSaidas();
    },

    alterarLimite() {
      this.paginaAtual = 1;
      this.carregarSaidas();
    },
    paginaAnterior() {
      if (this.paginaAtual > 1) {
        this.paginaAtual--;
        this.carregarSaidas();
      }
    },
    proximaPagina() {
      if (this.paginaAtual < this.totalPaginas) {
        this.paginaAtual++;
        this.carregarSaidas();
      }
    },
    irParaCadastro() {
      this.$router.push('/operacional/saidas-animais/novo');
    },
    async excluirSaida(id) {
      const confirmou = await this.$confirm(
        'Tem certeza que deseja excluir esta saída?',
        'Confirmação'
      );
      if (!confirmou) return;
      try {
        await axios.delete(`/operacional/saidas-animais/${id}`, {
          validateStatus: s => s >= 200 && s < 300
        });
        this.carregarSaidas();
        this.$toast.success('Saída excluída com sucesso!');
      } catch (e) {
        console.error('Erro ao excluir saída:', e);
        let msg = e.response?.data?.error || 'Erro ao excluir saída.';
        await this.$alert(msg, 'Não permitido');
      }
    }
  },
  async mounted() {
    this.carregarSaidas();
  }
};
</script>

<style scoped>
.same-height { height: 30px; padding: 6px 12px; font-size: .72rem; }

:deep(.pagination.pagination-sm .page-link) {
  padding: rem rem;
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}

</style>
